import React, { useRef } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import styles from "./ProjectCard.module.scss";

const ProjectCard = ({ item, className, squareThumbs = null }) => {
  const currentVideo = useRef();

  const isVideoPreview = item.thumb_special_hover;

  let request =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:3001/"
      : window.location.origin;

  const preview = item.preview
    ? `${request}${
        item.wide_block && !squareThumbs
          ? item.preview.wide?.url
          : item.preview.square?.url
      }`
    : require("../../assets/images/ajax-loader.gif");

  const second_preview =
    item.second_preview && item.second_preview.url
      ? `${request}${
          item.wide_block && !squareThumbs
            ? item.second_preview.wide?.url
            : item.second_preview.square?.url
        }`
      : null;

  const video_tag = item.video_preview?.url ? (
    <video
      autoPlay={isVideoPreview}
      muted={true}
      loop={item.video_preview_loop}
      ref={currentVideo}
      playsInline
      preload="auto"
      itemProp="video"
      className={classNames(styles.withVideoVideo, item.turn_off_smoothly || styles.Transition)}
    >
      {item.video_preview.webm_wide && (
        <source
          src={
            item.wide_block && !squareThumbs
              ? `${request}${item.video_preview.webm_wide?.url}`
              : `${request}${item.video_preview.webm_square?.url}`
          }
          type="video/webm"
        ></source>
      )}
      {item.video_preview.mp4_wide?.url && (
        <source
          src={
            item.wide_block && !squareThumbs
              ? `${request}${item.video_preview.mp4_wide?.url}`
              : `${request}${item.video_preview.mp4_square?.url}`
          }
          type="video/mp4"
        ></source>
      )}
    </video>
  ) : (
    ""
  );

  const video = (
    <Link
      className={classNames(styles.projectGridImage, styles.withVideo)}
      to={`/projects/${item.slug}`}
      onMouseEnter={() => (isVideoPreview ? stop() : play())}
      onMouseLeave={() => (isVideoPreview ? play() : stop())}
    >
      {video_tag}
      <img
        src={preview}
        alt={item.title}
        className={classNames(styles.withVideoImg, item.turn_off_smoothly || styles.Transition)}
      />
    </Link>
  );

  const image = (
    <Link className={styles.projectGridImage} to={`/projects/${item.slug}`}>
      <img
        src={preview}
        alt={item.title}
        className={classNames(second_preview ? (styles.imgFirst, item.turn_off_smoothly || styles.Transition) : styles.imgOnly)}
      />

      {second_preview ? (
        <img
          src={second_preview}
          alt={item.title}
          className={classNames(styles.imgSecond, item.turn_off_smoothly || styles.Transition)}
        />
      ) : (
        ""
      )}
    </Link>
  );

  const play = () => {
    const video = currentVideo.current;

    if (video) {
      video.play();
    }
  };

  const stop = () => {
    const video = currentVideo.current;

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  };

  // FIX IT
  const disableVideoPreviewProjects = ["yudinskiy-sayt"] // slugs
  const isDisableVideoPreview = disableVideoPreviewProjects.some(slug => slug === item.slug);

  return (
    <figure
      className={classNames(
        styles.ProjectCard,
        isVideoPreview && styles.alwaysOnHover,
        item.wide_block && !squareThumbs && styles.WideProject,
        className
      )}
    >
      {/* FIX IT */}
      {item.video_preview?.url && !isDisableVideoPreview ? video : image}

      <figcaption>
        <Link to={`/projects/${item.slug}`} className={styles.projectTitle}>
          {item.title}
        </Link>
      </figcaption>
    </figure>
  );
};

export default ProjectCard;
